import React, { useEffect } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { REQUIRED_ERR_MSG } from "../../Helper/Constants";
import {
  PLAN_STATUS_REACHED,
  PLAN_STATUS_SCHEDULE,
} from "../../../ConfigConstants/ConfigConstants";

const VhclDrPlanning = ({
  addTruckModalConfig,
  handleAddTruckClose,
  dropdownOpts,
  onSave,
}) => {
  const {
    register,
    control,
    setValue,
    reset,
    getValues,
    watch,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm();

  const onError = (err) => {
    console.error(err);
  };

  const watchDr1 = watch("driver1Id");
  const watchDr2 = watch("driver2Id");

  useEffect(() => {
    if (!!addTruckModalConfig?.data) {
      reset(addTruckModalConfig?.data);
    } else {
      reset({ truckId: 0, driver1Id: 0, driver2Id: 0 });
    }
  }, [addTruckModalConfig]);

  const isVhclDisable =
    addTruckModalConfig?.data?.planSts === PLAN_STATUS_SCHEDULE;
  const isDrDisable =
    addTruckModalConfig?.data?.planSts === PLAN_STATUS_REACHED;

  return (
    <Modal
      show={addTruckModalConfig.show}
      onHide={handleAddTruckClose}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="modal-title section-title">
            {addTruckModalConfig?.title}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <Container>
          <Row>
            <Col md={6}>
              {addTruckModalConfig?.data?.ordVhclTypeId > 0 && (
                <Row>
                  <div class="grd-bg p-2 p my-2 rounded-3">
                    <div class="fw-bold">Vehicle Type</div>
                    <div class="theme-blue-txt">
                      {addTruckModalConfig?.data?.ordVhclTypeTxt}
                    </div>
                  </div>
                </Row>
              )}
              <Row>
                <div className="grd-bg p-2 p my-2 rounded-3">
                  <div className="fw-bold">Rate Type</div>
                  <div className="theme-blue-txt">
                    {addTruckModalConfig?.data?.rateTypeTxt}
                  </div>
                </div>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <label className="form-label theme-blue-txt">
                  Vehicle <span className="text-danger">&#9733;</span>
                </label>
                <div>
                  <Controller
                    name={"truckId"}
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      min: { value: 1, message: REQUIRED_ERR_MSG },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        options={dropdownOpts?.vhclOpts}
                        value={dropdownOpts?.vhclOpts?.find(
                          (el) => el.value === value
                        )}
                        onChange={(opt) =>
                          !!opt ? onChange(opt.value) : onChange(0)
                        }
                        placeholder="Select Vehicle"
                        isSearchable={true}
                        isClearable={true}
                        className="form-control p-0"
                        // isDisabled={!isVhclDisable}
                      />
                    )}
                  />
                </div>
                <div>
                  {errors.truckId && (
                    <div>
                      <span className="badge bg-danger">
                        &#9888; {errors.truckId.message}
                      </span>
                    </div>
                  )}
                </div>
              </Row>
              <Row>
                <label className="form-label theme-blue-txt">
                  Driver 1 <span className="text-danger">&#9733;</span>
                </label>
                <div>
                  <Controller
                    name={"driver1Id"}
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: REQUIRED_ERR_MSG,
                      },
                      min: { value: 1, message: REQUIRED_ERR_MSG },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        options={dropdownOpts?.driverOpts}
                        value={dropdownOpts?.driverOpts.find(
                          (el) => el.value === value
                        )}
                        onChange={(opt) =>
                          !!opt ? onChange(opt.value) : onChange(0)
                        }
                        placeholder="Select Driver"
                        isSearchable={true}
                        isClearable={true}
                        className="form-control p-0"
                        isOptionDisabled={(opt) => opt.value === +watchDr2}
                        isDisabled={isDrDisable}
                      />
                    )}
                  />
                </div>
                <div>
                  {errors.driver1Id && (
                    <div>
                      <span className="badge bg-danger">
                        &#9888; {errors.driver1Id.message}
                      </span>
                    </div>
                  )}
                </div>
              </Row>
              <Row>
                <label className="form-label theme-blue-txt">Driver 2</label>
                <div>
                  <Controller
                    name={"driver2Id"}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        options={dropdownOpts?.driverOpts}
                        value={dropdownOpts?.driverOpts.find(
                          (el) => el.value === value
                        )}
                        onChange={(opt) =>
                          !!opt ? onChange(opt.value) : onChange(0)
                        }
                        placeholder="Select Driver"
                        isSearchable={true}
                        isClearable={true}
                        className="form-control p-0"
                        isOptionDisabled={(option) =>
                          option.value === +watchDr1
                        }
                        isDisabled={isDrDisable}
                      />
                    )}
                  />
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <Button
          onClick={handleSubmit(onSave, onError)}
          disabled={!isDirty}
          className="theme-violet"
        >
          SAVE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VhclDrPlanning;
